import styled, { css } from 'styled-components';

export const Content = styled.div`
  margin-left: 16px;
`;

export const Body = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 20px;
  border-top: 1px solid var(--cp-border, #ddd);
  padding-top: 20px;
`;

export const Left = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Label = styled.div`
  font-weight: bold;
  margin: 0 0 12px;
  &.zone {
    font-weight: normal;
    margin: 24px 0 10px;
  }
`;

export const Modes = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const Mode = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 18px;
  border: 2px solid var(--cp-border, #ddd);
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  ${(props) =>
    props.$active &&
    css`
      border-color: var(--cp-green, #47b972);
    `}
`;

export const Radio = styled.span`
  flex: none;
  width: 22px;
  height: 22px;
  box-sizing: border-box;
  border: 2px solid var(--cp-text-tertiary, #888);
  border-radius: 50%;
  position: relative;
  ${(props) =>
    props.$active &&
    css`
      border-color: var(--cp-green, #47b972);
      &:after {
        content: '';
        position: absolute;
        left: 4px;
        top: 4px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: var(--cp-green, #47b972);
      }
    `}
`;

export const Error = styled.div`
  color: #e5484d;
  font-size: 14px;
  margin: 14px 0 0;
`;

export const Right = styled.div`
  flex: none;
  width: 196px;
  text-align: center;
  font-size: 13px;
  color: var(--cp-text-tertiary, #888);
  margin-right: 10px;
`;

export const Screen = styled.div`
  display: flex;
  flex-direction: column;
  height: 292px;
  margin: 8px 0;
  box-sizing: border-box;
  border: 1px solid var(--cp-border, #ddd);
  border-radius: 10px;
  overflow: hidden;
`;

export const Places = styled.div`
  flex: 0 0 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: #000;
  font-size: 22px;
  font-weight: bold;
`;

export const Adv = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.25);
  font-size: 15px;
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
`;
